import * as React from 'react';
import { AbstractReactFactory } from '@projectstorm/react-canvas-core';

import NodeWidget from '../nodeWidget/NodeWidget';
import { NodeModelTypeEnum } from '../enums';
import { RefrigeratedAirDryerNodeModel } from './RefrigeratedAirDryerNodeModel';
import { RefrigeratedAirDryerNodeWidget } from './RefrigeratedAirDryerNodeWidget';

export class AirDryerRefrigeratedNodeFactory extends AbstractReactFactory {
  constructor(private isMainMap) {
    super(NodeModelTypeEnum.RefrigeratedAirDryer);
    this.isMainMap = isMainMap;
  }

  generateModel() {
    return new RefrigeratedAirDryerNodeModel();
  }

  nodeUI(event) {
    return <RefrigeratedAirDryerNodeWidget engine={this.engine} node={event.model} width={140} height={167} />;
  }

  generateReactWidget(event) {
    return this.isMainMap ? (
      <NodeWidget entity={event.model.getEntity()} onDevices={event.model.getOnDevices()}>
        {this.nodeUI(event)}
      </NodeWidget>
    ) : (
      this.nodeUI(event)
    );
  }
}
